import type { UserProfileResponse } from '@efex-services/auth/types';
import authSvc from '@efex-services/auth/authSvc';
import type { UseApiCallProps } from '@pages/lending/types';
import { useApiCall } from 'use-api-call';

interface UseGetUserProfileService {
  profileInformation: UserProfileResponse | null;
  loadingUserProfile: boolean;
  getUserProfile: () => void;
}

const useGetUserProfileService = (): UseGetUserProfileService => {
  const {
    data: profileInformation,
    loading: loadingUserProfile,
    invoke: getUserProfile,
  }: UseApiCallProps<UserProfileResponse, any> = useApiCall(() =>
    authSvc.getUserProfile()
  );
  return { profileInformation, loadingUserProfile, getUserProfile };
};

export default useGetUserProfileService;
